import React from 'react'
import ScrollWrap from '../components/ScrollWrap'
import Navbar from '../components/Navbar'
import MainWrap from '../components/MainWrap'
import ContactFormWrap from '../components/ContactFormWrap'
import Overlay from '../components/Overlay'
import SlickSlider2 from '../components/SlickSlider2'
import { SlickTestingData } from '../data/SlickSliderData'
import FundamentalCourses2 from '../components/FundamentalCourses2'
import FundamentalTestingData from '../data/FundamentalTestingData'
import CounterArea from '../components/CounterArea'
import { CounterData2 } from '../data/CounterData'
import Enroll from '../components/Enroll'
import { EnrollData5 } from '../data/EnrollData'
import RelatedCourses from '../components/RelatedCourses'
import Footer from '../components/Footer'
import ContactAnchor from '../components/ContactAnchor'
import LoginAnchor from '../components/LoginAnchor'

export default function TestingModule() {
    return (
        <>
            <ContactAnchor />
            <LoginAnchor />
            <ScrollWrap />
            <Navbar />
            <MainWrap />
            <ContactFormWrap />
            <Overlay />
            <SlickSlider2 data={SlickTestingData}/>
            <FundamentalCourses2 data={FundamentalTestingData}/>
            <CounterArea data={CounterData2} />
            <Enroll data={EnrollData5}/>
            <RelatedCourses />
            <Footer />
        </>
    )
}
